import { DateTime, Duration } from "@tento-chrono";
import type { Utc } from "@tento-chrono";
import type { StickerSlot } from "@tento-lona/sheets-ui/platform";
import { Column, Row } from "@tento-ui/component-builtin";
import { StickerEffect } from "@tento-ui/components/sticker/sticker-effect";
import { Storybook } from "@tento-ui/ui/storybook";

import { StickerDetails } from "./sticker-details";
import { CellId } from "@tento-lona/sheets";

export class StickerDetailsStoryBook extends Storybook.Default {
  title(): string {
    return "Sticker Picker";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Create picker",
        render: () => StickerDetailsStoryBook.$createPicker(),
      },
      {
        title: "Saved sticker editing",
        render: () => StickerDetailsStoryBook.$materialVariants(),
      },
    ];
  }
}

export namespace StickerDetailsStoryBook {
  export function $createPicker(): Storybook.RenderResult {
    const $status = Storybook.Card.StatusLine.make();
    $status.bindText("Click an asset to create the sticker.");
    const $picker = StickerDetails.make().bindCreate({
      onPickArt: (art) => $status.bindText(`created: ${art}`),
    });
    $picker.assignStyles({
      width: "264px",
    });
    return { $content: $picker, $status };
  }

  export function $materialVariants(): Storybook.RenderResult {
    const $status = Storybook.Card.StatusLine.make();
    $status.bindText("Click a tile to update an existing sticker.");
    const $root = Row.make();
    $root.assignStyles({
      gap: "12px",
      flexWrap: "wrap",
      padding: "16px",
      background: "var(--bg-surface-light)",
      borderRadius: "16px",
    });
    for (const effect of StickerEffect.ALL) {
      const $card = Column.make();
      $card.assignStyles({
        width: "264px",
        border: "1px solid var(--divider)",
        borderRadius: "12px",
        background: "var(--bg)",
        overflow: "hidden",
      });
      const item = slot(effect.id);
      $card.appendChild(StickerDetails.make().bindDetails({
        slot: item,
        onPickArt: (art) =>
          $status.bindText(`${StickerEffect.label(effect.id)} -> ${art}`),
        onDelete: () =>
          $status.bindText(`delete: ${StickerEffect.label(effect.id)}`),
      }));
      $root.appendChild($card);
    }
    return { $content: $root, $status };
  }

  function slot(effect: StickerEffect.Id): StickerSlot {
    return {
      id: `sticker-story-${effect}`,
      stickerId: "wildflowers",
      cellId: CellId.of(`story-${effect}`),
      timeRange: timeRange(),
      message: StickerEffect.label(effect),
      effect,
      x: 0.5,
    };
  }

  function timeRange(): DateTime.Range<Utc> {
    const start = DateTime.utc.now();
    return new DateTime.Range(start, start.add(Duration.Time.mins(30)));
  }
}
